import React from "react";
import {
  CircleMarker,
  MapContainer,
  TileLayer,
  Tooltip,
} from "react-leaflet";

import {
  DEFAULT_CENTER,
  DEFAULT_ZOOM,
  POINT_TYPES,
} from "../data/carteInteretsUiData";

import { MapFocusController, ResizeHandler } from "./MapControllers";

export default function CarteInteretsMap({
  loading,
  points = [],
  selectedPoint,
  onSelectPoint,
}) {
  if (loading) {
    return (
      <div className="flex h-[480px] items-center justify-center rounded-[2rem] border border-slate-200 bg-slate-100 text-sm font-semibold text-slate-500 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-400">
        Chargement de la carte…
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-100 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <MapContainer
        center={selectedPoint ? [selectedPoint.lat, selectedPoint.lng] : DEFAULT_CENTER}
        zoom={DEFAULT_ZOOM}
        className="h-[520px] w-full"
        scrollWheelZoom
      >
        <ResizeHandler />
        <MapFocusController points={points} selectedPoint={selectedPoint} />

        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {points.map((point) => {
          const type = POINT_TYPES[point.type] || POINT_TYPES.service;
          const selected = selectedPoint?.id === point.id;

          return (
            <CircleMarker
              key={point.id}
              center={[point.lat, point.lng]}
              radius={selected ? 12 : 8}
              pathOptions={{
                color: type.stroke,
                fillColor: type.color,
                fillOpacity: selected ? 0.96 : 0.82,
                weight: selected ? 4 : 2,
              }}
              eventHandlers={{
                click: () => onSelectPoint(point),
              }}
            >
              <Tooltip direction="top" offset={[0, -4]} opacity={0.95}>
                <div className="max-w-[220px] text-xs">
                  <p className="font-bold">{point.title}</p>
                  {point.category && (
                    <p className="mt-0.5 text-[11px] opacity-80">
                      {point.category}
                    </p>
                  )}
                  <p className="mt-1 text-[11px] font-semibold">
                    {type.singular}
                  </p>
                </div>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}